<template>
    <div>
        <b-checkbox v-show="!hide_list && (show_start_array || true)" v-model="start_array">Liste</b-checkbox>

        <json_schema_editor_value ref="editor" :show_required="show_required"/>
    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";
	import draggable from "vuedraggable";

    var clone = require("clone");

    import json_schema_editor_value from "./json_schema_editor_value";

    export default {
        name: "json_schema_editor",
        components: {
            draggable,
            json_schema_editor_value
        },
        props: {
            columns: [],
            show_start_array: {
                default: false
            },
            show_required: {
                default: true
            },
            hide_list: {
                default: false
            }
        },
        data: function () {
            return {
                data: {},
                id: uniqueId(),
                start_array: false		
            };
		},
		methods: {
            load(data)
            {
                console.log("load schema")
                this.data = data;

                console.log(JSON.stringify(data))

                data = this.schema_to_config(data)

                console.log(JSON.stringify(data))

                this.$refs.editor.load(data);
            },
            save()
            {
                console.log("save schema");

                var data = this.$refs.editor.save();

                console.log(JSON.stringify(data))

                data = this.config_to_schema(data)

                console.log(JSON.stringify(data))

                return (data);
            },
            config_to_schema_elem(config, schema, array)
            {
                if (array)
                {
                    var i = 0;
                    if (config[i].type == "string" || config[i].type == "number" || config[i].type == "boolean")
                    {
                        schema.items = {
                            type: config[i].type
                        }
                        if (config[i].enum && config[i].enum.length > 0) {
                            schema.items.enum = config[i].enum;
                        }
                    }
                    else if (config[i].type == "object")
                    {
                        schema.items = {
                            additionalProperties: false,
                            type: config[i].type,
                            properties: {}
                        }
                        schema.items = this.config_to_schema_elem(config[i].obj, schema.items, false);
                    }
                    else if (config[i].type == "array")
                    {
                        schema.items = {
                            type: config[i].type,
                            items: {}
                        }

                        schema.items = this.config_to_schema_elem(config[i].array, schema.items, true);
                    }

                    return schema;
                }
                else
                {
                    var required = [];
                    for (var i = 0; i < config.length; i++)
                    {
                        // Ignorer les champs avec colonne vide ou invalide
                        if (!config[i].column || !config[i].column.trim()) {
                            continue;
                        }
                        
                        schema.additionalProperties = false;
                        if (config[i].required && config[i].column && config[i].column.trim())
                            required.push(config[i].column)
                        if (config[i].type == "string" || config[i].type == "number" || config[i].type == "boolean")
                        {
                            schema.properties[config[i].column] = {
                                type: config[i].type
                            }
                            if (config[i].enum && config[i].enum.length > 0) {
                                schema.properties[config[i].column].enum = config[i].enum;
                            }
                        }
                        else if (config[i].type == "object")
                        {
                            schema.properties[config[i].column] = {
                                type: config[i].type,
                                properties: {}
                            }
                            schema.properties[config[i].column] = this.config_to_schema_elem(config[i].obj, schema.properties[config[i].column], false);
                        }
                        else if (config[i].type == "array")
                        {
                            schema.properties[config[i].column] = {
                                type: config[i].type,
                                items: {}
                            }

                            schema.properties[config[i].column] = this.config_to_schema_elem(config[i].array, schema.properties[config[i].column], true);
                        }
                    }

                    if (required.length > 0)
                        schema.required = [...new Set(required)];

                    return schema;
                }
            },
            config_to_schema(config)
            {
                var schema = {};

                if (!this.start_array)
                {    
                    schema.additionalProperties = false;
                    schema.type = "object";
                    schema.properties = {};

                    schema = this.config_to_schema_elem(config, schema, false);                 
                }
                else
                {
                    schema.type = "array";
                    schema.items = {
                        type: "object",
                        properties: {}
                    };  
                    schema.items = this.config_to_schema_elem(config, schema.items, false);                    
                }

                return schema;
            },
            schema_to_config_elem(schema, config)
            {
                console.log(schema.type)
                console.log(schema)

                if (schema.type == "object")
                {
                    var keys = Object.keys(schema.properties);

                    for (var i = 0; i < keys.length; i++)
                    {
                        var item = {
                            column: keys[i],
                            type: schema.properties[keys[i]].type,
                            required: (schema.required && schema.required.includes(keys[i])) ? true : false
                        }

                        if (schema.properties[keys[i]].enum) {
                            item.enum = schema.properties[keys[i]].enum;
                        }

                        if (schema.properties[keys[i]].type == "object")
                        {
                            item.obj = [];
                            item.obj = this.schema_to_config_elem(schema.properties[keys[i]], item.obj)
                        }
                        else if (schema.properties[keys[i]].type == "array")
                        {
                            item.array = [];
                            item.array = this.schema_to_config_elem(schema.properties[keys[i]], item.array)

                            // Si item.array[0] a une propriété .array, on l'extrait (cas des tableaux imbriqués)
                            // Sinon on garde item.array tel quel (cas des types simples comme string avec enum)
                            if (item.array && item.array[0] && item.array[0].array) {
                                item.array = item.array[0].array;
                            }
                        }

                        console.log(item)
                        
                        config.push(item);
                    }
                }
                else if (schema.type == "array")
                {
                    config.array = [];

                    console.log("config_array")
                    console.log(config)

                    if (schema.items.type == "object")
                    {
                        var item = {
                            column: "",
                            type: "array",
                            required: false,
                            array: [{
                                column: "",
                                type: "object",
                                required: false,
                                obj: []
                            }]
                        }

                        item.array[0].properties = this.schema_to_config_elem(schema.items, item.array[0].obj)

                        config.push(item);
                    }
                    else if (schema.items.type == "array")
                    {
                        var item = {
                            column: "",
                            type: "array",
                            required: false,
                            array: []
                        }

                        item.array = this.schema_to_config_elem(schema.items, item.array)

                        config.push(item);
                    }
                    else
                        config.array = this.schema_to_config_elem(schema.items, config)
                }
                else
                {
                    var item = {
                        column: "",
                        type: schema.type
                    }

                    if (schema.enum) {
                        item.enum = schema.enum;
                    }

                    config.push(item);
                }

                return config
            },
            schema_to_config(schema)
            {
                console.log("schema_to_config")

                var config = [];

                this.start_array = false;
                if (schema.type == "array")
                {
                    this.start_array = true;
                    config = this.schema_to_config_elem(schema.items, config);            
                }
                else
                {
                    config = this.schema_to_config_elem(schema, config);
                }

                return config;
            },
            get_data()
            {
                var data = this.save();

                return data;
            }
        },
		mounted: function () {
		}
    }

</script>